module.exports = __webpack_public_path__ + "img/beer_id-107.217b6304.png";